import { create } from 'zustand';

interface AuthUser {
    name: string;
    email: string;
}

interface AuthState {
    user: AuthUser | null;
    displayName: string | null;
    setUser: (user: AuthUser) => void;
    setDisplayName: (displayName: string | null) => void;
    clearUser: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
    user: null,
    displayName: null,
    setUser: (user) => set({ user }),
    setDisplayName: (displayName) => set({ displayName }),
    clearUser: () => set({ user: null, displayName: null }),
}));
